import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user is in the depleted state and tries to take a blocked action',
  name: 'depleted_action_blocked',
  params: [
    {
      description: 'The action that was blocked',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['upload', 'import', 'canvas_edit', 'asset_edit', 'workspace_agent'],
    },
    {
      description: 'Subscription plan name',
      name: 'plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Credit pack quantity currently on the subscription (0 if user has no packs)',
      name: 'existing_pack_quantity',
      required: true,
      type: 'number',
    },
    {
      description: 'Whether a credit pack change is already queued on the subscription',
      name: 'credit_pack_change_pending',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Number of credits remaining in the current cycle',
      name: 'credits_remaining',
      required: true,
      type: 'number',
    },
    {
      description: 'Percentage of credits used',
      name: 'pct_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of credits used in the current cycle',
      name: 'credits_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
